import {html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {classMap} from 'lit/directives/class-map.js';
import {
	AttributeType,
	ConfigurationInterpreter,
	DecisionKind
} from '@viamedici-spc/configurator-ts';
import {property} from 'lit/decorators/property.js';
import {live} from 'lit/directives/live.js';

import {SpcBaseAttribute} from './spcBaseAttribute';
import {attributeIdToString} from './util/spcUtils';
import {staggeredReveal} from '../../css/styleSets';
import {attributeWidget} from '../../css/attributeWidget';
import info from '../../../icons/info';
import reset from '../../../icons/reset';
import radio from '../../../icons/radio';
import radioChecked from '../../../icons/radio-checked';

@customElement('spc-boolean-attribute')
export class SpcBooleanAttribute extends SpcBaseAttribute {

	static styles = [
		staggeredReveal,
		attributeWidget,
		css`
			:host {
			}
		`];

	@property({type: Number})
	value = null;

	stateChanged(state) {
		super.stateChanged(state);

		if (this.spcConfiguration) {
			console.log('SpcBooleanAttribute stateChanged', this.attribute);
			if (this.attribute) {
				this.value = this.attribute.decision?.state ?? false;
			}
		}
	}
	async resetDecision() {
		this.session.makeDecision({
			type: AttributeType.Boolean,
			attributeId: this.attribute.id,
			state: null
		});
	}
	async applyValue(event) {
		const target = event.target;
		this.session.makeDecision({
			type: AttributeType.Boolean,
			attributeId: this.attribute.id,
			state: target.checked
		});
	}
	isSatisfied() {
		return this.attribute?.isSatisfied ?? false;
	}
	render() {
		return html`
			<div class="attribute ${classMap({satisfied: this.isSatisfied()})}">
				<div class="title">
					<div class='icon indicator'>${this.isSatisfied() ? radioChecked : radio}</div>
					<span class="label">
						<trans-label .showIdWhenMissing=${true} key="${this.attribute.key}" context="F" title="${this.attribute.key}"></trans-label>
					</span>
					<div class="tools">
						<button class='tools_button' @click="${this.showInfo}"><span class="icon">${info}</span></button>
						<button class='tools_button' @click="${this.resetDecision}"><span class="icon">${reset}</span></button>
					</div>
				</div>
				<div class="values">
					<input
						class="checkbox"
						type="checkbox"
						?checked="${live(this.value)}"
						@change="${this.applyValue}">
				</div>
			</div>

		`;
	}
}
